// Index files are intended for importing and executing functions and classes only. They should not contain any logic.

function search() {}

export default search
